import swaggerClient from '../../utility/swaggerClient';

export const getProjects = async () => {
  const client = await swaggerClient();
  const engagements = (await client.apis.engagement.get_engagement()).body;
  const projects = (await client.apis.project.get_project()).body;

  return { engagements, projects };
};

export const getProjectFiles = async projectId => {
  const client = await swaggerClient();
  const response = (await client.apis.file.get_project__projectId__file({
    projectId
  })).body;

  return response;
};

export const createEngagement = async engagementName => {
  const client = await swaggerClient();
  const response = (await client.apis.engagement.post_engagement({
    engagements: [{ engagementName }]
  })).body;

  return response[0];
};

export const createProject = async (
  projectName,
  engagementId,
  sourceLanguage,
  targetLanguage,
  workspace
) => {
  const client = await swaggerClient();
  const response = (await client.apis.project.post_project({
    projects: [
      {
        projectName,
        engagementId,
        sourceLanguage,
        targetLanguage,
        workspace
      }
    ]
  })).body;

  return response[0];
};

export const editEngagement = async (engagementId, engagementName) => {
  const client = await swaggerClient();
  const response = (await client.apis.engagement.put_engagement__engagementId_({
    engagementId,
    engagementObject: {
      engagementId,
      engagementName
    }
  })).body;

  return response;
};

export const editProject = async (
  projectId,
  projectName,
  engagementId,
  sourceLanguage,
  targetLanguage,
  workspace
) => {
  const client = await swaggerClient();
  const response = (await client.apis.project.put_project__projectId_({
    projectId,
    projectObject: {
      engagementId,
      projectId,
      projectName,
      sourceLanguage,
      targetLanguage,
      workspace
    }
  })).body;

  return response;
};

export const assignProject = async (
  { projectId, projectName, sourceLanguage, targetLanguage, workspace },
  { engagementId }
) => {
  const client = await swaggerClient();
  const response = (await client.apis.project.put_project__projectId_({
    projectId,
    projectObject: {
      engagementId,
      projectId,
      projectName,
      sourceLanguage,
      targetLanguage,
      workspace
    }
  })).body;

  return response;
};

export const deleteEngagement = async engagementId => {
  const client = await swaggerClient();
  const response = (await client.apis.engagement.delete_engagement__engagementId_(
    {
      engagementId
    }
  )).body;

  return response;
};

export const deleteProject = async projectId => {
  const client = await swaggerClient();
  const response = (await client.apis.project.delete_project__projectId_({
    projectId
  })).body;

  return response;
};



// WEBPACK FOOTER //
// ./src/state/projects/api.js